
/**
 * Build full avatar URL from relative path
 * @param relativePath - Relative path from backend like "/media/profile_pictures/Screenshot.png"
 * @returns Full URL or null if no path provided
 */
export const buildAvatarUrl = (relativePath?: string | null): string | null => {
  if (!relativePath) return null;

  const trimmed = relativePath.trim();
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')) {
    return trimmed.startsWith('//') ? `https:${trimmed}` : trimmed;
  }

  const baseUrl = process.env.REACT_APP_API_URL;
  if (!baseUrl) {
    console.warn('REACT_APP_API_URL is not defined');
    return null;
  }

  const base = baseUrl.replace(/\/+$/, '');
  const cleanPath = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;

  return `${base}/${cleanPath}`;
};

/**
 * Generate user initials from name or email
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @param email - User's email (fallback)
 * @param username - User's username (fallback)
 * @returns Initials string (1-2 characters)
 */
export const generateInitials = (firstName?: string, lastName?: string, email?: string, username?: string): string => {
  const first = firstName?.trim();
  const last = lastName?.trim();

  if (first && last) {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  } else if (first) {
    return first.charAt(0).toUpperCase();
  } else if (username) {
    return username.charAt(0).toUpperCase();
  } else if (email) {
    return email.charAt(0).toUpperCase();
  }
  return 'U';
};

/**
 * Generate initials from full name string
 * @param fullName - Full name like "John Doe"
 * @param email - Email fallback
 * @returns Initials string
 */
export const generateInitialsFromFullName = (fullName?: string, email?: string): string => {
  if (!fullName?.trim()) {
    return email ? email.charAt(0).toUpperCase() : 'U';
  }

  const names = fullName.trim().split(' ');
  if (names.length >= 2) {
    return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
  } else {
    return names[0].charAt(0).toUpperCase();
  }
};
